module.exports = __webpack_public_path__ + "img/Q4.9020c033.jpg";